module.exports = {
  template: require('./appointments-show-container.pug')()
  controller: require('./appointments-show-container.ctrl')
}
